import PropTypes from "prop-types";
import SmartDPPatchwork from "app/pages/SmartDP/Quote/SmartDPPatchwork";
import SimpleProgressiveImg from "app/pages/.shared/SimpleProgressiveImg";
import LineClampViewMore from "app/pages/.shared/LineClampViewMore/LineClampViewMore";
import { htmlSanitize } from "app/utils/sanitize";
import "./HotelDetails.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const HotelDetails = ({
	isMobile,
	printMode,
	photos = [],
	resolution,
	hotelSummary = "",
	openPhotosSlideshow,
}) => {
	const PHOTO_PRINT_IMG_SIZES = {
		small: { width: 800 },
		medium: { width: 800 },
		large: { width: 800 },
		xlarge: { width: 800 },
	};

	return (
		<div className="hotel-details">
			{!isMobile && photos.length > 0 && !printMode && (
				<SmartDPPatchwork photos={photos} onShowMore={openPhotosSlideshow} />
			)}

			{printMode && photos.length > 0 && (
				<SimpleProgressiveImg
					src={photos[0].url}
					resolution={resolution}
					sizes={PHOTO_PRINT_IMG_SIZES}
				/>
			)}

			{printMode ? (
				<div
					className="hotel-details__text"
					dangerouslySetInnerHTML={{ __html: htmlSanitize(hotelSummary) }}
				/>
			) : (
				<div className="hotel-details__text" data-testid="hotel-details">
					<LineClampViewMore
						enableShowMore={true}
						lineCount={isMobile ? 6 : 5}
						text={
							<Typography
								dangerouslySetInnerHTML={{
									__html: htmlSanitize(hotelSummary),
								}}
								component={"span"}
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
							/>
						}
						customShowMoreComponent={
							<div data-testid="read-more-button">
								<Button
									variant={BUTTON_VARIANTS.BORDERLESS}
									label={
										<>
											+ <FormattedMessage id="general.read.more" />
										</>
									}
								/>
							</div>
						}
						customShowLessComponent={
							<div data-testid="read-more-button">
								<Button
									variant={BUTTON_VARIANTS.BORDERLESS}
									label={
										<>
											- <FormattedMessage id="general.reduce" />
										</>
									}
								/>
							</div>
						}
					/>
				</div>
			)}
		</div>
	);
};

HotelDetails.propTypes = {
	isMobile: PropTypes.bool,
	printMode: PropTypes.bool,
	photos: PropTypes.array,
	resolution: PropTypes.string,
	hotelSummary: PropTypes.string,
	openPhotosSlideshow: PropTypes.func,
};

export default memo(HotelDetails);
